export const apiPath = '/v1/imports';
const actionType = 'IMPORT_UNITS';

export default actionType;
